import { CHAVE_TEMA, COR_NAVEGADOR, TEMA_PADRAO } from '@/constants/tema.constants';
import type { Tema } from '@/types/tema.types';

/**
 * Leitura, escrita e aplicação do tema.
 *
 * Tudo aqui tolera `localStorage` indisponível — modo privado, cota cheia, política de
 * cookies restritiva. Uma página de status que quebra por não conseguir gravar uma
 * preferência de cor falharia pelo motivo mais bobo possível.
 */

export function lerTemaSalvo(): Tema {
  try {
    return localStorage.getItem(CHAVE_TEMA) === 'escuro' ? 'escuro' : TEMA_PADRAO;
  } catch {
    return TEMA_PADRAO;
  }
}

export function gravarTema(tema: Tema): void {
  try {
    localStorage.setItem(CHAVE_TEMA, tema);
  } catch {
    // Sem persistência a escolha vale só para esta visita, e isso é aceitável.
  }
}

export function aplicarTema(tema: Tema): void {
  const escuro = tema === 'escuro';
  const raiz = document.documentElement;

  raiz.classList.toggle('dark', escuro);

  // Faz o navegador pintar barras de rolagem e controlos nativos no tema certo.
  raiz.style.colorScheme = escuro ? 'dark' : 'light';

  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', COR_NAVEGADOR[tema]);
}

export function alternarTema(tema: Tema): Tema {
  return tema === 'escuro' ? 'claro' : 'escuro';
}
